// extracted by mini-css-extract-plugin
export var container = "_fo-0";
export var dotAnimation = "_fo-2";
export var dotsLoading = "_fo-1";